import React, { useState } from 'react'
import { Button } from 'react-bootstrap'
import BootstrapTable from 'react-bootstrap-table-next'
import paginationFactory from 'react-bootstrap-table2-paginator'
import ToolkitProvider from 'react-bootstrap-table2-toolkit'
import MySearch from './SearchAsignatedresponsable'
import FormAsignatedResponsable from './FormAsignatedResponsable'

const TableAssignatedResponsable = ({ dataCases, form, user }) => {
  const defaultSorted = [
    {
      dataField: 'name',
      order: 'desc'
    }
  ]
  const data = []
  const [dataTable, setDataTable] = useState(data)
  const [dataOriginal] = useState(data)
  const [RowInfo, setRowInfo] = useState({})
  const [cellColums, setCellColums] = useState('TOTAL')
  const [modeAssignated, setmodeAssignated] = useState('218001')
  const [show, setShow] = useState(false)
  const handleClose = () => setShow(false)
  const gestionCase = dataCases
  const [respSolicitudAseg, setRespSolicitudAseg] = useState({})

  const onClick = (row) => {
    setShow(true)
    setRowInfo(row)
  }
  const columns = [
    {
      dataField: 'idResponsable',
      text: form['asigcaso-grilla-id'],
      sort: true,
      headerAlign: 'center',
      align: 'center'
    },
    {
      dataField: 'nombre',
      text: form['asigcaso-grilla-nombrers'],
      sort: true,
      headerAlign: 'center',
      align: 'center'
    },
    {
      dataField:
        cellColums === 'TOTAL'
          ? 'cntCasosCerrados'
          : cellColums === 'JUD'
          ? 'cntCasosCerJU'
          : 'cntCasosCerEJ',
      text: form['asigcaso-grilla-casoscerr'],
      sort: true,
      headerAlign: 'center',
      align: 'center'
    },
    {
      dataField:
        cellColums === 'TOTAL'
          ? 'cntCasosAbiertos'
          : cellColums === 'JUD'
          ? 'cntCasosAbiJU'
          : 'cntCasosAbiEJ',
      text: form['asigcaso-grilla-casospend'],
      sort: true,
      headerAlign: 'center',
      align: 'center'
    },
    {
      dataField:
        cellColums === 'TOTAL'
          ? 'totalCasos'
          : cellColums === 'JUD'
          ? 'totalCasosJU'
          : 'totalCasosEJ',
      text: form['asigcaso-grilla-totalcasos'],
      sort: true,
      headerAlign: 'center',
      align: 'center'
    },
    {
      dataField: 'tpoCierrePromedio',
      text: form['asigcaso-grilla-tpopromcierre'],
      sort: true,
      headerAlign: 'center',
      align: 'center'
    },
    {
      dataField:
        cellColums === 'TOTAL'
          ? 'montoRecuperoPromedio'
          : cellColums === 'JUD'
          ? 'montoPromRDJU'
          : 'montoPromRDEJ',
      text: form['asigcaso-grilla-mtorecprom'],
      sort: true,
      headerAlign: 'center',
      align: 'center'
    },
    {
      dataField: '',
      text: 'Acción',
      headerAlign: 'center',
      align: 'center',
      formatter: (cellContent, row) => {
        return (
          <Button
            type='button'
            onClick={() => onClick(row)}
            variant='asignar'
          >
            {form['asigcaso-btn-asigresponsable']}
          </Button>
        )
      }
    }
  ]

  return (
    <div className='App'>
      <div>
        <ToolkitProvider
          bootstrap4
          keyField='idResponsable'
          data={dataTable}
          columns={columns}
          search
        >
          {(props) => (
            <div>
              <MySearch
                {...props}
                setmodeAssignated={setmodeAssignated}
                setDataTable={setDataTable}
                dataOriginal={dataOriginal}
                gestionCase={gestionCase}
                formLabel={form}
                user={user}
                setCellColums={setCellColums}
                setRespSolicitudAseg={setRespSolicitudAseg}
              />

              <hr />

              <BootstrapTable
                defaultSorted={defaultSorted}
                pagination={paginationFactory({ sizePerPage: 25 })}
                {...props.baseProps}
              />
            </div>
          )}
        </ToolkitProvider>
        <hr style={{ color: '#04005D', height: '1px', marginTop:'30px' }}></hr>
        {show && (
          <FormAsignatedResponsable
            show={show}
            handleClose={handleClose}
            message='Esta Seguro que desea Recepcionar este Caso'
            caso={gestionCase}
            form={form}
            data={RowInfo}
            user={user}
            modeAssignated={modeAssignated}
            respSolicitudAseg={respSolicitudAseg}
          />
        )}
      </div>
    </div>
  )
}

export default TableAssignatedResponsable
